package net.gorillagroove.db

import com.squareup.sqldelight.ColumnAdapter
import kotlin.Long
import kotlin.String
import net.gorillagroove.api.UserId
import net.gorillagroove.user.RawUserVisibilityType
import net.gorillagroove.util.Instant

public data class DbUser(
  public val id: UserId,
  public val name: String,
  public val lastActivity: Instant?,
  public val createdAt: Instant,
  public val yourVisibility: RawUserVisibilityType,
  public val theirVisibility: RawUserVisibilityType
) {
  public override fun toString(): String = """
  |DbUser [
  |  id: $id
  |  name: $name
  |  lastActivity: $lastActivity
  |  createdAt: $createdAt
  |  yourVisibility: $yourVisibility
  |  theirVisibility: $theirVisibility
  |]
  """.trimMargin()

  public class Adapter(
    public val idAdapter: ColumnAdapter<UserId, Long>,
    public val lastActivityAdapter: ColumnAdapter<Instant, Long>,
    public val createdAtAdapter: ColumnAdapter<Instant, Long>,
    public val yourVisibilityAdapter: ColumnAdapter<RawUserVisibilityType, String>,
    public val theirVisibilityAdapter: ColumnAdapter<RawUserVisibilityType, String>
  )
}
